module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-论坛选择标签-灰.0cead.png";